module.exports = __webpack_public_path__ + "static/img/stay-option-icon-showerfacility.1d0922d5.svg";